import deepmerge from 'deepmerge';

import type { ThemeColors } from '../../../../tokens/colors/types';
import type { BaseDeprecatedColors } from '../../../types';
import derivedED from './ED';

export default (baseColors: ThemeColors): BaseDeprecatedColors => {
  return {
    ...deepmerge(derivedED(baseColors), {
      promotional: {
        primary: {
          default: baseColors.primary['90'],
          dark: '#0B1F00',
        },
        secondary: {
          default: baseColors.primary['30'],
          dark: baseColors.primary['70'],
        },
      },
    }),
  };
};
